module.exports = __webpack_public_path__ + "static/img/krungsri-auto-75-logo.134a9c2.svg";